import { render, staticRenderFns } from "./createResident.vue?vue&type=template&id=56273d9e&scoped=true"
import script from "./createResident.vue?vue&type=script&lang=js"
export * from "./createResident.vue?vue&type=script&lang=js"
import style0 from "./createResident.vue?vue&type=style&index=0&id=56273d9e&prod&lang=css"
import style1 from "./createResident.vue?vue&type=style&index=1&id=56273d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56273d9e",
  null
  
)

export default component.exports